import { createActions, createState, createReducer } from 'reduxsauce-crud'

const d = { deep: true }
const DEEP = { deep: true }

export const HealthTeacherRedux = createActions(
  {
    postHealthTeacherRequest: ['userId', 'data'],
    postHealthTeacherSuccess: ['data'],
    postHealthTeacherFailure: ['errors'],
    getQuestionHealthTeacherRequest: [],
    getQuestionHealthTeacherSuccess: ['data'],
    getQuestionHealthTeacherFailure: ['errors'],
    // resetError: [],
  },
  {
    prefix: 'HEALTH_TEACHER_',
    defaultActions: {
      get: true,
    },
  },
)

const { Types, Creators } = HealthTeacherRedux
export const HealthTeacherTypes = Types
export default Creators

export const INITIAL_STATE = createState({
  sending: {
    fetching: false,
    error: null,
  },
  questions:{
    fetching: false,
    error: null,
    results: []
  }
}, {
  get: true,
})

/* ------------- Reducers ------------- */
// const resetError = state => state.merge({ create: { fetching: false, error: null } }, d)

const postHealthTeacherRequest = state => state.merge({
  sending: {
    fetching: true,
    error: null,
  },
  get: {
    fetching:true,
    error:null
  }
}, d)

const postHealthTeacherSuccess = (state, { data }) => state.merge({
  sending: {
    fetching: false,
    error: null,
  },
  get:{
    results: data,
    fetching: false
  }
}, d)

const postHealthTeacherFailure = (state, { errors }) => state.merge({
  sending: {
    fetching: false,
  },
  get: {
    fetching:false,
    results:[],
    error:errors
  },
}, d)

const getQuestionHealthTeacherRequest = state => state.merge({
  sending: {
    fetching: true,
  },
  get: {
    fetching:true
  },
  questions: {
    error: '',
    fetching: true,
  },
}, d)

const getQuestionHealthTeacherSuccess = (state, { data }) => state.merge({
  sending: {
    fetching: false,
  },
  get: {
    fetching:false
  },
  questions: {
    error: '',
    fetching: false,
    results: data
  },
}, d)

const getQuestionHealthTeacherFailure = (state, { errors }) => state.merge({
  sending: {
    fetching: false,
  },
  get: {
    fetching:false,
    erros:errors,
  },
  questions: {
    error: errors,
    fetching: false,
  },
}, d)


export const reducer = createReducer(
  INITIAL_STATE, {
    [Types.postHealthTeacherRequest]: postHealthTeacherRequest,
    [Types.postHealthTeacherSuccess]: postHealthTeacherSuccess,
    [Types.postHealthTeacherFailure]: postHealthTeacherFailure,
    [Types.getQuestionHealthTeacherRequest]: getQuestionHealthTeacherRequest,
    [Types.getQuestionHealthTeacherSuccess]: getQuestionHealthTeacherSuccess,
    [Types.getQuestionHealthTeacherFailure]: getQuestionHealthTeacherFailure,
    // [Types.resetError]: resetError,
  },
  {
    defaultActions: {
      get: true,
    },
    Types,
  },
)



// WEBPACK FOOTER //
// ./src/Data/Redux/HealthTeacherRedux.js